import { gql } from '@apollo/client'

export const BLOG_POST_QUERY = gql`
  query blogPost($id: ID!) {
    blogPost(id: $id) {
      id
      title
      subtitle
      pinned
      content
      createdAt
      updatedAt
      categories
    }
  }
`
